module.exports = __webpack_public_path__ + "static/load-chart1-17fac5bd130d90961a60e748ceedab95.png";